import React from 'react';
import { Text, Flex } from '@fluentui/react-northstar';
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import Timer from '../../atoms/Timer'

const TimerContainer = observer((props) => {
    const { description, startTime, testId } = props;

    return (
        <Flex column data-testid={testId + "Container"}>
            <Text weight="semibold" content={description} data-testid={testId + "Description"} />
            <Timer startTime={startTime} data-testid={testId + "Timer"} />
        </Flex>
    );
});

TimerContainer.propTypes = {
    description: PropTypes.string,
    startTime: PropTypes.string,
    testId: PropTypes.string,
};

TimerContainer.defaultProps = {
    description: "",
    startTime: "",
    testId: "",
}

export default TimerContainer;